(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = parts[0];
    amount = parts.join('.');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product, variantMedia = {};
    try {
      var data = JSON.parse(jsonEl.textContent);
      product = data.product;
      variantMedia = data.variantMedia || {};
    } catch (e) { return; }

    var form = root.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atcBtn = root.querySelector('[data-atc]');
    var saleEl = root.querySelector('[data-price-sale]');
    var compareEl = root.querySelector('[data-price-compare]');
    var badgeEl = root.querySelector('[data-price-badge]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) values[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return values;
    }

    function findVariant(values) {if (product.variants.length === 1) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function setImageForVariant(variant) {
      if (!variant) return;
      var mediaId = variantMedia[String(variant.id)];
      if (!mediaId) return;
      var thumb = root.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
      if (thumb && !thumb.classList.contains('thumb--hidden')) thumb.click();
    }

    /* Color-scoped gallery: only show images tagged for the selected color.
       Tagging happens in Liquid (color name found in the image filename or alt
       text -> data-color-group). Untagged images always stay visible. */
    var colorIndex = -1;
    (product.options || []).forEach(function (name, i) {
      if (colorIndex === -1 && /colou?r/i.test(String(name))) colorIndex = i;
    });

    function applyColorGroup(colorValue) {
      if (!colorValue) return;
      var group = String(colorValue).toLowerCase();
      var thumbs = root.querySelectorAll('[data-thumb]');
      if (!thumbs.length) return;
      var anyVisible = false;
      thumbs.forEach(function (t) {
        var g = t.dataset.colorGroup || '';
        var show = !g || g === group;
        t.classList.toggle('thumb--hidden', !show);
        if (show) anyVisible = true;
      });
      if (!anyVisible) {
        thumbs.forEach(function (t) { t.classList.remove('thumb--hidden'); });
      }
      var active = root.querySelector('[data-thumb].thumb--active');
      if (!active || active.classList.contains('thumb--hidden')) {
        var first = root.querySelector('[data-thumb]:not(.thumb--hidden)');
        if (first) first.click();
      }
    }

    function updateLabels(values) {
      values.forEach(function (val, i) {
        var label = root.querySelector('[data-option-label="' + i + '"]');
        if (label) label.textContent = val;
      });
    }

    function onVariantChange() {
      var values = selectedOptions();
      updateLabels(values);
      if (colorIndex > -1) applyColorGroup(values[colorIndex]);
      var variant = findVariant(values);

      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (saleEl) saleEl.textContent = formatMoney(variant.price);
      if (stickyPrice) {
        var tierNow = root.querySelector('[data-tier-input]:checked');
        stickyPrice.textContent = formatMoney(tierNow ? parseInt(tierNow.dataset.totalCents, 10) : variant.price);
      }

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
        compareEl.classList.toggle('hidden', !hasCompare);
      }
      if (badgeEl) {
        if (hasCompare) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          badgeEl.textContent = 'Save ' + pct + '%';
          badgeEl.classList.remove('hidden');
        } else {
          badgeEl.classList.add('hidden');
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcBtn.dataset.labelAdd : 'Sold out';
      }
      setImageForVariant(variant);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });

    /* Gallery — items (images or videos) toggle by media id; videos pause when hidden */
    function activateMedia(mediaId) {
      root.querySelectorAll('[data-media-item]').forEach(function (item) {
        var active = String(item.dataset.mediaItem) === String(mediaId);
        item.classList.toggle('media-item--active', active);
        if (!active) {
          item.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (_) {} });
        }
      });
    }
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(thumb.dataset.mediaId);
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('thumb--active'); });
        thumb.classList.add('thumb--active');
      });
    });

    /* Quantity */
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; });
    });
    root.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
    });

    /* Add to cart */
    var stickyBtnRef = document.querySelector('[data-sticky-button]');
    function setBusy(busy, original) {
      if (atcBtn) { atcBtn.disabled = busy; atcBtn.textContent = busy ? 'Adding...' : original; }
      if (stickyBtnRef) stickyBtnRef.disabled = busy;
    }
    function showAddError(msg) {
      var box = root.querySelector('[data-add-error]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-add-error', '');
        box.setAttribute('role', 'alert');
        box.style.cssText = 'margin:1rem 0 0;padding:1rem 1.2rem;border-radius:8px;background:#FBE9E7;color:#8E2F46;font-size:1.5rem';
        if (atcBtn && atcBtn.parentNode) atcBtn.parentNode.insertBefore(box, atcBtn.nextSibling);
      }
      box.textContent = msg;
    }
    function clearAddError() { var b = root.querySelector('[data-add-error]'); if (b) b.remove(); }

    function completeAdd(original) {
      setBusy(false, original);
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.dataset.drawerEnabled === 'true') {
        refreshCart().then(openDrawer);
      } else {
        window.location.href = window.routes.cart_url;
      }
    }

    function submitAdd(body, isJson, discountCode) {
      if (atcBtn && atcBtn.disabled) return;
      var original = atcBtn ? (atcBtn.dataset.labelAdd || atcBtn.textContent) : '';
      clearAddError();
      setBusy(true, original);
      var opts = { method: 'POST', headers: { 'Accept': 'application/json' } };
      if (isJson) {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
      } else {
        opts.body = body;
      }
      fetch(window.routes.cart_add_url + '.js', opts)
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j && (j.description || j.message) ? (j.description || j.message) : 'add failed');
            return j;
          });
        })
        .then(function () {
          if (discountCode) {
            return fetch('/discount/' + encodeURIComponent(discountCode)).catch(function () {});
          }
        })
        .then(function () { completeAdd(original); })
        .catch(function (err) {
          setBusy(false, original);
          showAddError((err && err.message && err.message !== 'add failed') ? err.message : 'Sorry, that did not go through. Please try again, or email us and we will help.');
        });
    }

    /* Bundle & save */
    var bundleEl = root.querySelector('[data-bundle]');
    var bundle = null;
    if (bundleEl) {
      var optionValues = product.options.map(function (name, i) {
        var seen = [], key = 'option' + (i + 1);
        product.variants.forEach(function (v) {
          if (seen.indexOf(v[key]) === -1) seen.push(v[key]);
        });
        return seen;
      });

      var thumbSrcFor = function (values) {
        var v = findVariant(values);
        var mediaId = v ? variantMedia[String(v.id)] : null;
        var thumb = mediaId ? root.querySelector('[data-thumb][data-media-id="' + mediaId + '"]') : null;
        if (!thumb) {
          var wantIdx = colorIndex > -1 ? colorIndex : 0;
          var want = String(values[wantIdx] || values[0] || '').toLowerCase();
          root.querySelectorAll('[data-thumb]').forEach(function (t) {
            if (thumb) return;
            if ((t.dataset.alt || '').toLowerCase() === want) thumb = t;
            else if ((t.dataset.colorGroup || '') === want) thumb = t;
          });
        }
        var img = thumb ? thumb.querySelector('img') : root.querySelector('[data-thumb] img');
        return img ? img.src : '';
      };

      var syncRowThumb = function (row) {
        var values = [];
        row.querySelectorAll('select').forEach(function (s) {
          values[parseInt(s.dataset.optIndex, 10)] = s.value;
        });
        var src = thumbSrcFor(values);
        if (src) row.querySelector('img').src = src;
      };

      var buildRows = function (tier, qty) {
        var rows = tier.querySelector('[data-tier-rows]');
        if (!rows || rows.childElementCount > 0 || qty < 2) return;
        for (var r = 0; r < qty; r++) {
          var row = document.createElement('div');
          row.className = 'bundle__row';
          var img = document.createElement('img');
          img.alt = '';
          img.width = 50;
          img.height = 50;
          row.appendChild(img);
          var singleDefault = product.variants.length === 1 && (product.options.length === 0 || /^title$/i.test(String(product.options[0])));
          optionValues.forEach(function (values, oi) {
            if (singleDefault) return;
            var sel = document.createElement('select');
            sel.setAttribute('aria-label', product.options[oi] + ' for item ' + (r + 1));
            sel.dataset.optIndex = oi;
            values.forEach(function (val) {
              var o = document.createElement('option');
              o.value = val;
              o.textContent = val;
              sel.appendChild(o);
            });
            sel.value = selectedOptions()[oi] || values[0];
            sel.addEventListener('change', function (e) { syncRowThumb(e.target.closest('.bundle__row')); }); /* v10g: was closing over the loop's shared var row, so only the last row's thumb ever updated */
            row.appendChild(sel);
          });
          /* Engraved products: each necklace in the bundle gets its own name */
          if (document.getElementById('personalize-name-input')) {
            var nameIn = document.createElement('input');
            nameIn.type = 'text';
            nameIn.maxLength = 10;
            nameIn.placeholder = 'Name for necklace ' + (r + 1);
            nameIn.dataset.rowName = '1';
            nameIn.autocomplete = 'off';
            nameIn.setAttribute('aria-label', 'Name to engrave for necklace ' + (r + 1));
            nameIn.style.cssText = 'flex:1;min-width:12rem;padding:1rem 1.2rem;border:1px solid rgba(0,0,0,.35);border-radius:8px;font-size:1.7rem;background:#fff';
            row.appendChild(nameIn);
          }
          rows.appendChild(row);
          syncRowThumb(row);
        }
      };

      var activeTierInput = function () {
        return bundleEl.querySelector('[data-tier-input]:checked');
      };

      var onTierChange = function () {
        var checked = activeTierInput();
        bundleEl.querySelectorAll('[data-tier]').forEach(function (tier) {
          var input = tier.querySelector('[data-tier-input]');
          var isActive = input === checked;
          tier.classList.toggle('bundle__tier--active', isActive);
          var qty = parseInt(input.dataset.qty, 10) || 1;
          if (isActive && qty > 1) buildRows(tier, qty);
          var rows = tier.querySelector('[data-tier-rows]');
          if (rows) rows.hidden = !isActive || qty < 2;
        });
        if (checked && stickyPrice) {
          stickyPrice.textContent = formatMoney(parseInt(checked.dataset.totalCents, 10));
        }
        /* Engraved products: on multi-piece tiers the per-row name fields take over,
           hide the single main field so nobody types a name that gets ignored */
        var mainNameInput = root.querySelector('#personalize-name-input');
        if (mainNameInput) {
          var activeQty = checked ? (parseInt(checked.dataset.qty, 10) || 1) : 1;
          var grp = mainNameInput.closest('.option-group');
          if (activeQty > 1) {
            if (grp) grp.style.display = 'none';
            mainNameInput.required = false;
          } else {
            if (grp) grp.style.display = '';
            mainNameInput.required = true;
          }
        }
      };

      bundleEl.querySelectorAll('[data-tier-input]').forEach(function (input) {
        input.addEventListener('change', onTierChange);
      });
      if (!activeTierInput()) {
        var firstTier = bundleEl.querySelector('[data-tier-input]');
        if (firstTier) firstTier.checked = true;
      }
      onTierChange();

      var timerEl = bundleEl.querySelector('[data-bundle-timer]');
      if (timerEl) {
        var left = (parseInt(timerEl.dataset.minutes, 10) || 0) * 60;
        var disp = timerEl.querySelector('[data-timer-display]');
        var tick = setInterval(function () {
          left -= 1;
          if (left <= 0) { clearInterval(tick); timerEl.hidden = true; return; }
          var m = Math.floor(left / 60), s = left % 60;
          disp.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        }, 1000);
      }

      var personalProps = function () {
        var props = {}, has = false;
        root.querySelectorAll('[data-product-form] input[name^="properties["]').forEach(function (i) {
          var m = i.name.match(/^properties\[(.+)\]$/);
          if (m && i.value) { props[m[1]] = i.value; has = true; }
        });
        return has ? props : null;
      };

      bundle = {
        add: function () {
          var checked = activeTierInput();
          if (!checked) return;
          var qty = parseInt(checked.dataset.qty, 10) || 1;
          var code = checked.dataset.code || '';
          var lines = [];
          if (qty < 2) {
            var v = findVariant(selectedOptions());
            if (!v || !v.available) { alert('This combination is unavailable.'); return; }
            lines.push({ id: v.id, quantity: 1 });
          } else {
            var bad = false, missingName = null;
            checked.closest('[data-tier]').querySelectorAll('.bundle__row').forEach(function (row) {
              var values = [];
              row.querySelectorAll('select').forEach(function (s) {
                values[parseInt(s.dataset.optIndex, 10)] = s.value;
              });
              var rv = findVariant(values);
              if (!rv || !rv.available) { bad = true; return; }
              var nameIn = row.querySelector('[data-row-name]');
              if (nameIn) {
                /* engraved: one line per necklace, each with its own name */
                var nm = nameIn.value.trim();
                if (!nm) { if (!missingName) missingName = nameIn; return; }
                lines.push({ id: rv.id, quantity: 1, properties: { 'Name to engrave': nm } });
              } else {
                var existing = lines.find(function (l) { return l.id === rv.id; });
                if (existing) existing.quantity += 1;
                else lines.push({ id: rv.id, quantity: 1 });
              }
            });
            if (bad) {
              alert('One of your selected combinations is sold out. Please pick another color or size.');
              return;
            }
            if (missingName) {
              missingName.focus();
              alert('Please type the name to engrave on each necklace.');
              return;
            }
          }
          var pp = personalProps();
          if (pp) lines.forEach(function (l) { l.properties = Object.assign({}, pp, l.properties || {}); });
          submitAdd({ items: lines }, true, code);
        }
      };
    }

    function validPersonalization() {
      /* trim typed names so a name of only spaces can never reach the cart */
      var ok = true;
      form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
        if (i.type === 'hidden') return;
        i.value = i.value.replace(/\s+/g, ' ').trim();
        if (i.required && !i.value) ok = false;
      });
      form.querySelectorAll('select[required]').forEach(function (s) { if (!s.value) ok = false; });
      if (form.reportValidity && !form.reportValidity()) ok = false;
      if (!ok) {
        var firstBad = form.querySelector(':invalid') || form.querySelector('input[required]:not([type=hidden])');
        if (firstBad && firstBad.focus) firstBad.focus();
      }
      return ok;
    }
    function handleSubmit() {
      if (!validPersonalization()) return;
      if (bundle) { bundle.add(); return; }
      submitAdd(new FormData(form), false, '');
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleSubmit();
      });
    }

    /* Sticky add-to-cart */
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('sticky-atc--visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -60px 0px' });
      observer.observe(atcBtn);
      var stickyBtn = sticky.querySelector('[data-sticky-button]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (atcBtn && atcBtn.disabled) return;
          handleSubmit();
        });
      }
    }

    onVariantChange();
  }

  /* ---------- Cart drawer ---------- */
  var drawerEl = null;

  var drawerReturnFocus = null;
  function openDrawer() {
    if (!drawerEl) return;
    drawerReturnFocus = document.activeElement;
    drawerEl.classList.add('cart-drawer--open');
    document.body.style.overflow = 'hidden';
    var c = drawerEl.querySelector('[data-cart-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('cart-drawer--open');
    document.body.style.overflow = '';
    if (drawerReturnFocus && drawerReturnFocus.focus) { try { drawerReturnFocus.focus(); } catch (_) {} }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    if (!drawerEl) return;
    var itemsEl = drawerEl.querySelector('[data-cart-items]');
    var subtotalEl = drawerEl.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    var shipBar = drawerEl.querySelector('[data-ship-bar]');
    if (shipBar) {
      var threshold = parseInt(shipBar.dataset.threshold, 10) || 0;
      var shipText = shipBar.querySelector('[data-ship-bar-text]');
      var shipFill = shipBar.querySelector('[data-ship-bar-fill]');
      if (threshold > 0 && shipText && shipFill) {
        var remaining = threshold - cart.total_price;
        shipText.textContent = remaining > 0
          ? "You're " + formatMoney(remaining) + ' away from free shipping'
          : 'Free shipping unlocked!';
        shipFill.style.width = Math.min(100, Math.round((cart.total_price * 100) / threshold)) + '%';
      }
    }
    if (!itemsEl) return;

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_140x$1$2') + '" alt="" width="70" height="70" loading="lazy">'
        : '<div style="width:70px;height:70px"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-item__meta">' + esc(item.variant_title) + '</div>' : '';
      var props = '';
      Object.keys(item.properties || {}).forEach(function (k) {
        var v = item.properties[k];
        if (!k || k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
        props += '<div class="cart-item__meta">' + esc(k) + ': ' + esc(v) + '</div>';
      });
      var saving = (item.original_line_price && item.final_line_price < item.original_line_price)
        ? '<div class="cart-item__saving">You save ' + formatMoney(item.original_line_price - item.final_line_price) + '</div>' : '';
      return (
        '<div class="cart-item">' +
          img +
          '<div>' +
            '<div class="cart-item__title">' + esc(item.product_title) + '</div>' +
            variant +
            props +
            '<div class="cart-item__meta">Qty ' + item.quantity + '</div>' +
            saving +
            '<button class="cart-item__remove" data-cart-remove data-line="' + (index + 1) + '">Remove</button>' +
          '</div>' +
          '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
        '</div>'
      );
    }).join('');

    itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  function refreshCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { window.location.href = window.routes.cart_url; });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawerEl = document.querySelector('[data-cart-drawer]');
    if (drawerEl) {
      var overlay = drawerEl.querySelector('[data-cart-overlay]');
      var close = drawerEl.querySelector('[data-cart-close]');
      if (overlay) overlay.addEventListener('click', closeDrawer);
      if (close) close.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
      document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (drawerEl.dataset.drawerEnabled !== 'true') return;
          e.preventDefault();
          refreshCart().then(openDrawer);
        });
      });
    }
    document.querySelectorAll('[data-product]').forEach(initProduct);
  });
})();
